module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"back_to":"に戻る "}}')
  delete Component.options._Ctor
}
